module.exports = __webpack_public_path__ + "static/media/Nestor.4917d0a3.jpg";